module.exports = __webpack_public_path__ + "static/media/img-products-teams.4c3f8dbe.png";